export default {
	init() {
    window.renderAsset = function(file, type, videoId) {
      var refresh ="https://" + window.location.host + window.location.pathname + '?videoId=' + videoId;    
      window.history.pushState({ path: refresh }, '', refresh); 

      document.querySelector('.spinner').style.display = 'block';
      $('#asset-rev').foundation('open');
      setTimeout(() => {
        let postData = type+'&'+file;
        $.ajax({
         type: "POST",
         url: '/wp-content/themes/2022-truepic/resources/render-ajax.php',
         data: { file: file, type: type },
         beforeSend:function(data) {
           document.querySelector('.spinner').style.display = 'block';
         },
         success:function(data) {
          document.querySelector('.spinner').style.display = 'none';
          $('#asset-rev').html(data);
        },
      });
      }, '500');
    }
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/videos.js